import angular from 'angular';

import feedbackComponent from './components/feedbackComponent';

const feedbackModule = angular.module('sling.feedback', []);
feedbackModule.component('feedbackModal', feedbackComponent);

export default feedbackModule.name;
